import { render, staticRenderFns } from "./userGroupEditDialog.vue?vue&type=template&id=a6fe141e&"
import script from "./userGroupEditDialog.vue?vue&type=script&lang=js&"
export * from "./userGroupEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports